module.exports = __webpack_public_path__ + "img/the-flute.77107794.webp";